import React from 'react';

import { StyledHr } from './HrStyles';

/**
 * Render hr tag
 *
 * @returns {React.ReactElement}
 */
function Hr() {
  return <StyledHr />;
}

export default Hr;
